export default __webpack_public_path__ + "99f7f0dbf5761184c64a5be0b9193541.svg";